import { useEffect, useState } from "react"
import { LatestAppointmentsScreen } from "../../screen/LatestAppointmentsScreen"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import { customToast } from "../../components/Toast"
import Send from "../../core/communication"
import { useSelector } from "react-redux"
import moment from "moment"
import { useAssistanceTags } from "../../core/utils/hooks/useTags"

const loadData = async (projectId, setData, scopeType) => {
  try {
    const response = await Send.get(`/events-sector/executed/responsible/${projectId}`, `scopeType=${scopeType}`);

    if(!response || response.status === 'error') {
      throw new Error(response.data);
    }
    setData(response || []);
  } catch(error) {
    console.log("Erro ao buscar Últimos Atendimentos", error);
    customToast("Erro ao buscar Últimos Atendimentos", 'error');
  }
}

const loadNotExecutedData = async (projectId, setData, scopeType) => {
  try {
    const response = await Send.get(`/events-sector/responsible/${projectId}`, `scopeType=${scopeType}`);

    if(!response || response.status === 'error') {
      throw new Error(response.data);
    }

    setData(response.data.map(item => ({ ...item, userNames: item?.userNames.map(row => row?.name) || [] })) || []);
  } catch(error) {
    console.log("Erro ao buscar Últimos Atendimentos", error);
    customToast("Erro ao buscar Últimos Atendimentos", 'error');
  }
}

export const LatestAppointmentsContainer = () => {
  const [filter, setFilter] = useState({
    date: null,
    tags: null
  });
  const { scope, scopeType } = useScope();
  const user = useUser();
  const { tagsOptions } = useAssistanceTags();
  const isUserAdmin = useSelector((state) => state.app.isUserAdmin || false)
  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [notExecutedData, setNotExecutedData] = useState([]);
  const [modalActions, setModalActions] = useState(false)
  const [openDetails, setOpenDetails] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState({})
  const [isAssistanceModalOpen, setIsAssistanceModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedAssistances, setSelectedAssistances] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([])
  const [tab, setTab] = useState('executed');
  
  useEffect(() => {
    if(scope && scope?.id && user.id && !modalActions) {
      if(tab === 'executed') {
        loadData(scope?.id, setData, scopeType);
      } else {
        loadNotExecutedData(scope?.id, setNotExecutedData, scopeType)
      }
    }
  }, [scope, tab, modalActions]);
  
  useEffect(() => {
    if(scope?.id && tab) {
      setSelectedRows([])
      setFilter({ date: null, tags: null });
    }
  }, [scope, tab]);
  
  useEffect(() => {
    if(reload) {
      if(tab === 'executed') {
        loadData(scope?.id, setData, scopeType);
        
      } else {
        loadNotExecutedData(scope?.id, setNotExecutedData, scopeType)
      }
      setReload(false);
    }
  }, [reload]);

  useEffect(() => {
    if(tab === 'executed' || tab === "not_executed") {
      goBack()  
    }
  }, [tab]);

  const handleOpenActionsModal = () => setModalActions(true);

  const handleCloseActionsModal = () => setModalActions(false);

  const handleCloseAssistanceModal = () => {
    setIsAssistanceModalOpen(false);
  }

  const handleOpenAssistanceModal = (dataRow) => {
    setIsAssistanceModalOpen(true);

    setSelectedAssistances(dataRow ?? []);
  }

  const handleSelectedUsers = (value) => {
    let newSelectedUser = value
    .map((item, index) => {
      delete item.user?.image;
      
      if (value && value?.slice(0, index)?.find((row) => row?.user?.email === item?.user?.email)) {
        return null
      }
      return item.user
    })
    .filter((user) => user)
    setSelectedRows(value)
    setSelectedUsers(newSelectedUser ?? [])
    
  }
 
  const handleEventStatus = () => {
    const getStatus = data?.filter((item) => selectedRows.includes(item.id))
    .filter(status => status.isFinished === 'Executado')
   
    if(getStatus.length) {
      customToast("Você selecionou um evento que já foi executado", "error")
      return;
    }

    handleExecuteAssistance();
  }

  const handleExecuteAssistance = async () => {
    customToast('Executando eventos...', 'info');

    try {
      const response = await Send.post('/events-sector/execute', {
        data: selectedRows
      })
      
      if(!response || !response.status === 'error') {
        throw new Error(response);
      }

      setReload(true);
      setModalActions(false);
      customToast('Eventos executados com sucesso.', 'success');
      
    } catch(error) {
      console.log('Erro ao executar eventos.', error);
      customToast('Erro ao executar eventos. Tente novamente ou entre em contato com o suporte!', 'error');
    }
  }

  const handleRemoveTag = async (tagLinkId) => {
    try {
      const response = await Send.delete(`/tags-assistance-link/${tagLinkId}`)
      if (response.status === "success") {
        customToast('Tag removida', 'success');
        setReload(true);
      }
    } catch(error) {
      console.log('Erro ao tentar remover tag', error);
      customToast('Erro ao tentar remover tag', 'error');
    }
  }
  
  const applyFilter = (currentData) => {
    let newFilteredData = currentData || [];

    if(filter?.tags && filter?.tags.length && tab === 'executed') {
      newFilteredData = newFilteredData.filter(row => row.tags.find(item =>
        filter?.tags.map(tag => tag.value).includes(item.id))
      );
    }

    if(filter.date && filter.date.split('|').length) {
      newFilteredData = newFilteredData?.filter(item => {
        let [startDate, endDate] = filter.date ? filter.date?.split('|') : [];
        startDate = moment(startDate);
        endDate = moment(endDate);
        
        const dateToCompare = moment(item?.createdAt);

        return (dateToCompare === startDate || dateToCompare === endDate) || (dateToCompare.isAfter(startDate) && dateToCompare.isBefore(endDate))
      });
    }

    return newFilteredData;
  }

  const handleChangeCurrentTab = (currentTab) => {
    setTab(currentTab);
  }

  const handleChangeFilter = (key, value) => {
    setFilter({
      ...filter,
      [key]: value
    })
  }

  const handleOpendDetails = (data) => {
    setSelectedEvent(data)
    setOpenDetails(true)
  }

  const goBack = () => {
    setSelectedEvent({})
    setOpenDetails(false)
  }

  return (
    <LatestAppointmentsScreen
      {...{
        data: applyFilter(tab === 'executed' ? data : notExecutedData),
        handleEventStatus,
        modalActions,
        handleOpenActionsModal,
        handleCloseActionsModal,
        selectedUsers,
        handleSelectedUsers,
        selectedRows,
        handleCloseAssistanceModal,
        handleOpenAssistanceModal,
        isAssistanceModalOpen,
        selectedAssistances,
        isUserAdmin,
        handleChangeCurrentTab,
        tab,
        tagsOptions,
        handleChangeFilter,
        handleRemoveTag,
        handleOpendDetails,
        openDetails,
        selectedEvent,
        goBack,
        filter
      }}
    />
  )
}